<div class="input-container">
  <div class="input-section">
    <div class="input-wrapper">
      <div class="input-content">
        <textarea
          #messageInput
          [(ngModel)]="messageText"
          (ngModelChange)="onMessageTextChange()"
          (keydown)="onKeyDown($event)"
          (input)="adjustTextareaHeight($event)"
          [placeholder]="(isCurrentConversationPolling$ | async) ? 'Nova is thinking... Please wait.' : 'Ask a followup or type in a new request. Nova responds like a real human.'"
          [disabled]="(isCurrentConversationPolling$ | async) || false"
          class="message-input"
          [class.polling]="(isCurrentConversationPolling$ | async) || false">
        </textarea>

        <!-- Uploaded Files Display -->
        <div class="uploaded-files" *ngIf="attachments.length > 0">
          <div class="uploaded-file" *ngFor="let attachment of attachments">
            <div class="file-icon">
              <img src="assets/icons/navigator/csv-file-icon.svg" alt="csv">
            </div>
            <span class="file-name">{{ attachment.name }}</span>
            <button class="remove-file-btn" (click)="removeAttachment(attachment.id)" title="Remove file">
              <img src="assets/icons/navigator/close-icon.svg" alt="close">
            </button>
          </div>
        </div>
      </div>

      <div class="input-actions">
        <div
          class="nova-context-controls"
          role="group"
          [attr.aria-disabled]="(isCurrentConversationPolling$ | async) ? 'true' : null"
          [class.addons-disabled]="isCurrentConversationPolling$ | async">
          <filter-section buttonTitle="Filter" [openUpward]="true"></filter-section>
          <nova-date-range-filter [openUpward]="true" [ngStyle]="{'margin-top': '10px'}"></nova-date-range-filter>
          <timezone [openUpward]="true"></timezone>
        </div>

        <button
          class="send-btn"
          (click)="onSendMessage()"
          [disabled]="(!messageText.trim() && attachments.length === 0) || ((isCurrentConversationPolling$ | async) || false)"
          type="button"
          title="Send message">
          <img src="assets/icons/navigator/send-icon.svg" alt="send">
        </button>
      </div>
    </div>
  </div>
</div>
